import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  align-items: center;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
`;

export const Paragraph = styled.p`
  font-size: 16px;
  color: #595959;
  margin: 0;
`;
